import React from 'react';
import type { FormField } from '../interfaces';
import { VedleggSelector } from './VedleggSelector';

type VedleggListSelectorProps = {
    field: FormField;
    isReadOnly: boolean;
    isRequired: boolean;
    prosessInstansId: string;
};

const prosjektVedleggType = 'Prosjektskjema vedlegg';

export const VedleggListSelector = ({
    field,
    isReadOnly,
    isRequired,
    prosessInstansId,
}: VedleggListSelectorProps) => {
    return (
        <VedleggSelector
            field={field}
            isReadOnly={isReadOnly}
            isRequired={isRequired}
            prosessInstansId={prosessInstansId}
            attachmentType={prosjektVedleggType}
        />
    );
};
